"use client";
import { useDialogStore } from "@/store/zustand/useDialogStore";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,

} from "./ui/dialog";


export const DialogComponent = () => {
  const { isOpen, closeDialog, children, title, description } =
    useDialogStore();
  return (
    <Dialog onOpenChange={closeDialog} open={isOpen} defaultOpen={isOpen}>
      <DialogContent className="p-2sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        {children && children}
      </DialogContent>
    </Dialog>
  );
};
